import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpService } from '../../services/http.service';
import Swal from 'sweetalert2';
import { UsersService } from '../../services/users.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  
  isChangePassword: Boolean = true;
  form: FormGroup = new FormGroup({});
  isLoading: boolean | undefined;
  typeUser: any;
  token: any;

  constructor(private router: Router, private formBuilder: FormBuilder, private httpService: HttpService, private route: ActivatedRoute, private usersService: UsersService) { 
    this.typeUser = this.route.snapshot.paramMap.get('typeUser');
    if (this.typeUser != 'candidat' && this.typeUser != 'consultant' && this.typeUser != 'entreprise' && this.typeUser != 'admin') {
      this.router.navigate(['/not-found']);
    }
  }

  ngOnInit() {
    const currentRoute = this.router.url;
    this.isChangePassword = (currentRoute.includes("changer-mot-de-passe")) ? true : false;

    const currentUser = this.usersService.getCurrentUser();
    this.token = (currentUser) ? currentUser.token : null;
    
    if (!this.isChangePassword) {
      this.route.queryParams
        .subscribe(params => {
          this.token = params.token;
        }
      );
    }
    this.initForm();
  }

  initForm() {
    if (this.isChangePassword) {
      this.form = this.formBuilder.group({
        oldPassword: ['', Validators.required],
        newPassword: ['', Validators.required],
        confirmPassword: ['', Validators.required],
      });
    } else {
      this.form = this.formBuilder.group({
        newPassword: ['', Validators.required],
        confirmPassword: ['', Validators.required],
      });
    }
  }

  onSubmitForm() {
    let formValue: any = this.form.value;
    formValue['token'] = this.token;
    formValue['type_user'] = this.typeUser;
    
    this.isLoading = true;
    if (!this.isChangePassword) { // Create new password
      if (formValue['newPassword'] === formValue['confirmPassword']) {
        this.httpService.createPassword(formValue).subscribe(
          (response: any) => {
            if (response.status == "success") {
              this.form.reset();
              this.isLoading = false;
              Swal.fire({
                icon: 'success',
                title: 'Excellent!',
                text: 'Mot de passe créé avec succès.',
              }).then(() => {
                window.location.href = window.location.origin + "/connexion";
              });
            }
          },
          (error) => {
            this.isLoading = false;
            if (error.error.message && error.error.message == 'USER_NOT_FOUND') {
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Veuillez réinitialiser votre mot de passe avant d\'effectuer cette opération.',
              })
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Vérifier votre connexion puis réessayée.',
              })
            }
          }
        );
      } else {
        this.isLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Nouveau mot de passe incorrect.',
        })
      }
    } else { // Change password
      if (formValue['newPassword'] === formValue['confirmPassword']) {
        this.httpService.changePassword(formValue).subscribe(
          (response: any) => {
            if (response.status == "success") {
              this.form.reset();
              this.isLoading = false;
              Swal.fire({
                icon: 'success',
                title: 'Excellent!',
                text: 'Mot de changé avec succès.',
              }).then(() => {
                location.reload();
              });
            }
          },
          (error) => {
            this.isLoading = false;
            if (error.error.message && error.error.message == 'OLD_PASSWORD_INCORRECT') {
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Ancien mot de passe incorrecte.',
              })
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Vérifier votre connexion puis réessayée.',
              })
            }
          }
        );
      } else {
        this.isLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Nouveau mot de passe incorrect.',
        })
      }
    }
  }

}
